/* eslint-disable import/prefer-default-export,react/forbid-prop-types,import/no-unresolved */
import React from 'react';
import PropTypes from 'prop-types';
import { MAIN_ICON_COLORS } from 'assets/components';
import BackgroundCard from 'assets/images/us-card-bg-disabled.png';
import { cardProviders } from '../../../../screens/Card/constants';
import { CardLogo } from '../CardLogo';
import Icon from '../../../../components/Icon';
import { ICONS } from '../../../../components/Icon/constants';
import { Typography } from '../../../../components';

export const DisabledCard = ({ cardStatus, cardProvider, label, openCardSettingModal }) => {
  if (cardProvider === cardProviders.GALILEO) {
    const galileoIPAN = cardStatus?.card_masked_number?.match(/.{1,4}/g);

    return (
      <div>
        <div
          style={{
            height: '15rem',
          }}
          className="d-flex flex-column position-relative w-100 rounded-extra pb-0">
          <div
            className="w-100 h-100 position-absolute top-0 left-0 rounded-extra"
            style={{
              backgroundImage: `url(${BackgroundCard})`,
              backgroundSize: '100% 100%',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center',
            }}
          />
          <div className="d-flex flex-column px-3 pt-3 h-100" style={{ zIndex: 10 }}>
            <div className="d-flex flex-row justify-content-between pb-5">
              <div className="d-flex align-items-center">{label}</div>
              <div className="d-flex flex-row">
                <div className="position-relative d-flex justify-content-center align-items-center rounded-extra p-2 cursor-pointer">
                  <div
                    className="position-absolute rounded-extra bg-shadow top-0 bottom-0 bg-shadow w-100 h-100"
                    style={{ backdropFilter: 'blur(4px)', opacity: '0.6' }}
                  />
                  <div
                    onClick={() => openCardSettingModal()}
                    tabIndex={-1}
                    role="presentation"
                    className="d-flex justify-content-center align-items-center"
                    style={{ width: '1.3rem', height: '1.3rem', zIndex: 10 }}>
                    <Icon icon={ICONS.SETTING} color={MAIN_ICON_COLORS.WHITE} />
                  </div>
                </div>
              </div>
            </div>
            <div className="d-flex flex-row align-items-end pb-4">
              <Typography as="p" variant="baseBold" className="text-white">
                {galileoIPAN && galileoIPAN?.length === 4
                  ? `${galileoIPAN[0]} **** **** ${galileoIPAN[3]}`
                  : '**** **** **** ****'}
              </Typography>
            </div>
            <div className="d-flex flex-row flex-fill justify-content-end align-items-center">
              <CardLogo
                cardProvider={cardProvider}
                cardNetwork={cardStatus?.network?.toUpperCase() || ''}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 370 218"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <rect width="370" height="218" rx="12" fill="black" />
      <rect
        opacity="0.6"
        x="0.5"
        y="0.5"
        width="369"
        height="217"
        rx="11.5"
        fill="url(#paint0_linear_19084_153888)"
        stroke="url(#paint1_linear_19084_153888)"
      />
      <CardLogo
        cardNetwork={cardStatus?.network?.toUpperCase() || ''}
        cardProvider={cardProvider}
      />

      <text fill="#717070" fontWeight="bold" fontSize={16} x={15} y={122}>
        {cardProvider === cardProviders.MONAVATE
          ? cardStatus?.cardNumberObscured?.match(/.{1,4}/g).join(' ')
          : cardStatus?.cardNumberObscured?.replaceAll('-', ' ')}
      </text>

      <text fill="white" fontWeight="600" fontSize={12} x={20} y={40}>
        {label}
      </text>

      <g>
        <path
          d="M322.22 26.4666C322.601 20.8425 327.131 16.4493 332.761 16.1616C334.629 16.0661 336.511 16 338.142 16C339.683 16 341.45 16.0591 343.218 16.1463C348.985 16.4307 353.568 21.0229 353.851 26.7903C353.939 28.6031 354 30.419 354 32C354 33.581 353.939 35.3969 353.851 37.2097C353.568 42.9771 348.985 47.5693 343.218 47.8537C341.45 47.9409 339.683 48 338.142 48C336.511 48 334.629 47.9339 332.761 47.8384C327.131 47.5507 322.601 43.1575 322.22 37.5334C322.091 35.6148 322 33.6763 322 32C322 30.3237 322.091 28.3852 322.22 26.4666Z"
          fill="white"
          fillOpacity="0.1"
        />
        <rect
          x="330.5"
          y="27"
          width="15"
          height="10.8333"
          rx="2"
          stroke="white"
          strokeWidth="1.5"
        />
        <path d="M333.834 34.5H333.842" stroke="white" strokeWidth="2" strokeLinecap="round" />
        <path d="M331.334 31.166H345.501" stroke="white" strokeWidth="2" strokeLinecap="round" />
      </g>

      <defs>
        <linearGradient
          id="paint0_linear_19084_153888"
          x1="370"
          y1="0.24809"
          x2="292.961"
          y2="280.088"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="white" stopOpacity="0.5" />
          <stop offset="0.390033" stopColor="white" stopOpacity="0.33" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_19084_153888"
          x1="-7.18182e-07"
          y1="100"
          x2="370"
          y2="102.5"
          gradientUnits="userSpaceOnUse">
          <stop stopOpacity="0.6" />
          <stop offset="1" stopColor="white" stopOpacity="0.6" />
        </linearGradient>
        <clipPath id="clip0_19084_153888">
          <rect width="51.5487" height="40" fill="white" transform="translate(302.451 162)" />
        </clipPath>
        <clipPath id="clip1_19084_153888">
          <rect width="51.5487" height="40" fill="white" transform="translate(302.451 162)" />
        </clipPath>
      </defs>
    </svg>
  );
};

DisabledCard.propTypes = {
  cardStatus: PropTypes.object,
  cardProvider: PropTypes.string,
  label: PropTypes.string,
  openCardSettingModal: PropTypes.func.isRequired,
};

DisabledCard.defaultProps = {
  cardStatus: null,
  cardProvider: null,
  label: '',
};
